import styled from "styled-components";

export const AddAchCardCardTitle = styled.div`
    margin: 10px 0px 0px 0px;
    text-align: center;
    font-size: var(--general-header-font-size);
    font-weight: var(--general-header-font-weight);
`;